import { Box, HStack } from '@chakra-ui/react'

interface ProgressStepperBarProps {
  stepCount: number
  currentStep: number
  completed?: string
  inProgress?: string
  notStarted?: string
}

const ProgressStepperBar = ({
  stepCount,
  currentStep,
  completed = 'black',
  inProgress = 'black',
  notStarted = 'gray.300',
}: ProgressStepperBarProps) => {
  const steps = new Array(stepCount).fill(0)
  return (
    <HStack spacing="24px" display="flex" h="6px" paddingX="67px">
      {steps.map((_: any, index: number) => {
        const componentStep = index + 1
        let bg =
          currentStep > componentStep
            ? completed
            : currentStep < componentStep
              ? notStarted
              : inProgress
        return <Box w="100px" h="full" bg={bg} rounded="full" key={index} />
      })}
    </HStack>
  )
}

export default ProgressStepperBar
